import { ApolloError, useQuery } from '@apollo/client'
import { Country, EmployeesAndTagsQuery, EmployeesAndTagsQueryVariables } from '../../../types'
import { EMPLOYEES_AND_TAGS } from '../Queries'

export default (
  companyId: string,
  country: Country,
): {
  data: EmployeesAndTagsQuery | undefined
  error: ApolloError | undefined
  loading: boolean
  startPolling: (pollInterval: number) => void
  stopPolling: () => void
} => {
  const variables = {
    companyId,
    country,
  }

  const { data, error, loading, startPolling, stopPolling } = useQuery<EmployeesAndTagsQuery, EmployeesAndTagsQueryVariables>(
    EMPLOYEES_AND_TAGS,
    {
      variables: variables,
    },
  )

  return { data, error, loading, startPolling, stopPolling }
}
